export const DEBUG: boolean = import.meta.env.DEV && import.meta.env.VITE_DEBUG === 'true';
export const serverUrl: string = import.meta.env.VITE_API_URL || 'https://bukovel.com/api/v1/ski/map/trails/lifts/';
